var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiguregolf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16.9331 31.6055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 31.6055,
    opacity: 0,
    width: 16.9331,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0193 8.27344C14.4255 8.27344 15.5622 7.125 15.5622 5.69531C15.5622 4.30078 14.4255 3.15234 13.0193 3.15234C11.5896 3.15234 10.4412 4.30078 10.4412 5.69531C10.4412 7.125 11.5896 8.27344 13.0193 8.27344ZM7.11303 31.4766C7.75756 31.4766 8.29662 30.9492 8.29662 30.293L8.29662 24.4453L11.0388 20.4023C11.1443 20.2383 11.3787 20.2852 11.4021 20.4961L11.824 24.1055C11.8474 24.3047 11.8826 24.4102 11.9763 24.6328L14.2849 30.7148C14.5662 31.4531 15.2458 31.6055 15.7966 31.4062C16.3474 31.1953 16.7693 30.6328 16.488 29.8828L14.2146 23.8359L14.2146 12.6797C14.2146 11.4258 13.6872 10.125 12.4802 9.63281L11.7419 9.32812C10.3826 8.76562 9.10521 8.92969 7.95678 9.75L5.17943 11.7539L2.07396 10.4414L8.23803 1.89844L10.2888 1.89844C10.8162 1.89844 11.2497 1.46484 11.2497 0.949219C11.2497 0.410156 10.8162 0 10.2888 0L8.34349 0C8.13256 0 7.92162 0.09375 7.79271 0.269531L0.245838 10.7227C-0.164319 11.2852-0.0705687 12.1055 0.5974 12.3867L4.86303 14.2148C5.05053 14.2852 5.17943 14.2969 5.44896 14.2969L8.27318 14.2969C8.71849 14.2969 8.87084 14.5898 8.87084 14.918L8.87084 18.1641L6.04662 23.5195C5.94115 23.7188 5.91771 23.8711 5.91771 24.0938L5.91771 30.293C5.91771 30.9492 6.44506 31.4766 7.11303 31.4766Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiguregolf);
export default __webpack_public_path__ + "static/media/figure.golf.aadd169e195ca2ba38e5335a98419184.svg";
export { ForwardRef as ReactComponent };